import * as React from 'react';

import { FocusIndicator } from '~shared/components/FocusIndicator';
import { IconChevron } from '~shared/components/icons/micro';

export function RoleMenuTriggerButton({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <button
      slot="trigger"
      className="group relative flex items-center border-0 rounded-2 bg-transparent pl-0 appearance-none  content-center gap-1 h-full cursor-pointer focus:outline-none role-action-menu"
    >
      <span className="capitalize font-sans text-base text-blue-900">
        {children}
      </span>
      <IconChevron direction="down" />
      <FocusIndicator />
    </button>
  );
}
